import axios from "axios";

const Axios = axios.create({
  baseURL: "https://www.triunfador.net/api",
});

export default Axios;
